import * as React from "react";
import { makeStyles } from "@material-ui/core";
import { classNames } from "@util/html.util";

export interface AsanaLogoProps {
  className?: string;
}

const useStyles = makeStyles({
  container: {},
  bold: {
    fontWeight: "bold",
  },
  st0: { fill: "#2E3C54" },
  st1: { clipPath: "url(#SVGID_2_)", fill: "url(#SVGID_3_)" },
});

export const AsanaLogo = ({ className }: AsanaLogoProps) => {
  const classes = useStyles();

  return (
    <div className={classNames([classes.container, className])}>
      <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 288 57.7"
        xmlSpace="preserve"
      >
        <g>
          <g>
            <path
              className={classes.st0}
              d="M110.9,43.1c0.2,1.9,1.6,4.2,4.2,4.2h1.5c0.6,0,1.1-0.5,1.1-1.1V13.1h0c0-0.6-0.5-1-1.1-1h-4.7
			c-0.6,0-1,0.4-1.1,1h0v2.7c-2.9-3.5-7.4-5-11.9-5c-10.3,0-18.6,8.3-18.6,18.6C80.4,39.7,88.7,48,99,48v0
			C103.5,48,108.4,46.3,110.9,43.1L110.9,43.1z M99,41.5c-6.5,0-11.8-5.4-11.8-12.1c0-6.7,5.3-12.1,11.8-12.1
			c6.5,0,11.8,5.4,11.8,12.1C110.8,36.1,105.5,41.5,99,41.5z"
            />
            <path
              className={classes.st0}
              d="M186.9,43.1c0.2,1.9,1.6,4.2,4.2,4.2h1.5c0.6,0,1.1-0.5,1.1-1.1V13.1h0c0-0.6-0.5-1-1.1-1H188
			c-0.6,0-1,0.4-1.1,1h0v2.7c-2.9-3.5-7.4-5-11.9-5c-10.3,0-18.6,8.3-18.6,18.6c0,10.3,8.3,18.6,18.6,18.6v0
			C179.6,48,184.5,46.3,186.9,43.1L186.9,43.1z M175.1,41.5c-6.5,0-11.8-5.4-11.8-12.1c0-6.7,5.3-12.1,11.8-12.1
			c6.5,0,11.8,5.4,11.8,12.1C186.9,36.1,181.6,41.5,175.1,41.5z"
            />
            <path
              className={classes.st0}
              d="M272,43.1c0.2,1.9,1.6,4.2,4.2,4.2h1.5c0.6,0,1.1-0.5,1.1-1.1V13.1h0c0-0.6-0.5-1-1.1-1H273
			c-0.6,0-1,0.4-1.1,1h0v2.7c-2.9-3.5-7.4-5-11.9-5c-10.3,0-18.6,8.3-18.6,18.6c0,10.3,8.3,18.6,18.6,18.6v0
			C264.6,48,269.5,46.3,272,43.1L272,43.1z M260.1,41.5c-6.5,0-11.8-5.4-11.8-12.1c0-6.7,5.3-12.1,11.8-12.1
			c6.5,0,11.8,5.4,11.8,12.1C271.9,36.1,266.6,41.5,260.1,41.5z"
            />
            <path
              className={classes.st0}
              d="M235.6,44.2l0-17.1h0c0-9.7-6.1-16.2-15.8-16.2c-4.6,0-8.9,2.7-9.8,5c-0.3-1.8-1.2-3.7-4.2-3.7h-1.5
			c-0.6,0-1.1,0.5-1.1,1.1v29.9c0,0,0,0,0,0v3.2v0.1h0c0,0.6,0.5,1,1.1,1h3.2h1.5c0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0
			c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1-0.1c0,0,0,0,0.1,0c0,0,0.1-0.1,0.1-0.1c0,0,0,0,0,0c0,0,0.1-0.1,0.1-0.1c0,0,0,0,0,0
			c0.1-0.2,0.2-0.4,0.2-0.6h0v-0.1v-2.1v-0.6V26.8c0-5.2,4.2-9.4,9.4-9.4s9.4,4.2,9.4,9.4l0,16.4l0,0c0,0,0,0,0,0v3.1v0.1h0
			c0,0.6,0.5,1,1.1,1h3.2h1.5l0,0c0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1-0.1c0,0,0,0,0.1,0
			c0,0,0.1-0.1,0.1-0.1c0,0,0,0,0,0c0,0,0.1-0.1,0.1-0.1c0,0,0,0,0,0c0.1-0.2,0.2-0.4,0.2-0.6c0,0,0,0,0,0h0v-0.1L235.6,44.2
			L235.6,44.2z"
            />
            <path
              className={classes.st0}
              d="M128.8,38.3c3.1,2.2,6.5,3.2,9.8,3.2c3.1,0,6.3-1.6,6.3-4.4c0-3.8-7-4.3-11.4-5.8c-4.4-1.5-8.2-4.6-8.2-9.6
			c0-7.7,6.8-10.8,13.2-10.8c4,0,8.2,1.3,10.9,3.2c0.9,0.7,0.4,1.5,0.4,1.5l-2.6,3.7c-0.3,0.4-0.8,0.8-1.5,0.3
			c-0.7-0.4-3.3-2.3-7.2-2.3c-3.9,0-6.2,1.8-6.2,4c0,2.7,3,3.5,6.6,4.4c6.2,1.7,13,3.7,13,11.3c0,6.8-6.3,10.9-13.3,10.9
			c-5.3,0-9.8-1.5-13.6-4.3c-0.8-0.8-0.2-1.5-0.2-1.5l2.6-3.7C127.9,37.9,128.5,38.1,128.8,38.3z"
            />
          </g>
          <g>
            <defs>
              <path
                id="SVGID_1_"
                d="M51.1,14.6c0,7-5.7,12.7-12.7,12.7c-7,0-12.7-5.7-12.7-12.7c0-7,5.7-12.7,12.7-12.7
				C45.5,1.9,51.1,7.5,51.1,14.6z M21.9,30.4c-7,0-12.7,5.7-12.7,12.7c0,7,5.7,12.7,12.7,12.7c7,0,12.7-5.7,12.7-12.7
				C34.6,36.1,29,30.4,21.9,30.4z M54.9,30.4c-7,0-12.7,5.7-12.7,12.7c0,7,5.7,12.7,12.7,12.7c7,0,12.7-5.7,12.7-12.7
				C67.6,36.1,62,30.4,54.9,30.4z"
              />
            </defs>
            <clipPath id="SVGID_2_">
              <use xlinkHref="#SVGID_1_" style={{ overflow: "visible" }} />
            </clipPath>

            <radialGradient
              id="SVGID_3_"
              cx="-17234.873"
              cy="4066.3691"
              r="42.6497"
              gradientTransform="matrix(0 -0.75 0.75 0 -3011.3389 -12892.8828)"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0" style={{ stopColor: "#FFB900" }} />
              <stop offset="0.6" style={{ stopColor: "#F95D8F" }} />
              <stop offset="0.9991" style={{ stopColor: "#F95353" }} />
            </radialGradient>
            <path
              className={classes.st1}
              d="M38.4,1.3c17.7,0,32,14.3,32,32c0,17.7-14.3,32-32,32c-17.7,0-32-14.3-32-32C6.5,15.6,20.8,1.3,38.4,1.3z"
            />
          </g>
        </g>
      </svg>
    </div>
  );
};
